import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.frontend_buttons.length)?_c('div',[_vm._l((_vm.frontend_buttons),function(b,idx){return _c(VBtn,{key:idx,attrs:{"x-small":"","color":"primary"},domProps:{"textContent":_vm._s(b.description)},on:{"click":function($event){return _vm.run_button(b)}}})}),(_vm.success)?_c('div',{staticClass:"success"},[_vm._v("\n        действие успешно выполнено\n    ")]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }